/** Icon paths (24×24, filled) shared by the bar, the landing, the console and Call me. */

// a handset
export const PHONE_ICON =
  "M6.6 3h3.2l1.6 4.4-2.1 1.4a10.5 10.5 0 0 0 5.9 5.9l1.4-2.1L21 14.2v3.2A2.6 2.6 0 0 1 18.4 20 15.4 15.4 0 0 1 4 5.6 2.6 2.6 0 0 1 6.6 3z";

// a handset with incoming-call waves
export const RING_ICON = "M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1zM15 3a6 6 0 0 1 6 6h-1.6A4.4 4.4 0 0 0 15 4.6zm0 3.2A2.8 2.8 0 0 1 17.8 9h-1.6A1.2 1.2 0 0 0 15 7.8z";
